// Shared helpers for loading and exporting board images.

// Load an image File/Blob into an HTMLImageElement, resolving once decoded.
// Used by the upload button, clipboard paste, and drag-and-drop so they all
// behave identically.
export const loadImageFromFile = (file) =>
  new Promise((resolve, reject) => {
    if (!file || !file.type || !file.type.startsWith('image/')) {
      reject(new Error('Not an image file'));
      return;
    }
    const img = new window.Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => resolve(img);
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to decode image'));
    };
    img.src = objectUrl;
  });

// Find the first image file in a clipboard or drag DataTransfer-like object.
export const getImageFileFromDataTransfer = (dataTransfer) => {
  if (!dataTransfer) return null;
  const { files, items } = dataTransfer;
  if (files && files.length) {
    for (const file of files) {
      if (file.type && file.type.startsWith('image/')) return file;
    }
  }
  if (items && items.length) {
    for (const item of items) {
      if (item.kind === 'file' && item.type && item.type.startsWith('image/')) {
        return item.getAsFile();
      }
    }
  }
  return null;
};
